export const USER_PERMISSIONS = {
  ORG_MEMBERSHIP_INVITE: 'membership:invite',
  ORG_MEMBERSHIP_DELETE: 'membership:delete',
  ORG_MEMBERSHIP_VIEW: 'membership:view',
  ORG_SUBSCRIPTION_MANAGE: 'subscription:manage',
  ORG_BLANK_DOCUMENT_CREATE: 'blank_document:create',
  ORG_DOCUMENT_LIBRARY_READ: 'document_library:read',
  ORG_DOCUMENT_LIBRARY_MANAGE: 'document_library:manage',
  ORG_DOCUMENT_LIBRARY_DOWNLOAD: 'document_library:download',
  //ORG_DOCUMENT_LIBRARY_CREATE_CONTRACT: 'document_library:create_contract', /// Aligned with the backend, no usage, will delete after testing
  ORG_DOCUMENT_TEMPLATE_READ: 'document_template:read',
  ORG_DOCUMENT_TEMPLATE_EDIT: 'document_template:edit',
  ORG_DOCUMENT_TEMPLATE_CREATE: 'document_template:create',
  //ORG_DOCUMENT_TEMPLATE_CREATE_CONTRACT: 'document_template:create_contract', /// Aligned with the backend, no usage, will delete after testing
  ORG_DOCUMENT_TEMPLATE_DELETE: 'document_template:delete',
  ORG_DOCUMENT_CONTRACT_READ: 'document_contract:read', /// Perhaps, will use it instead
  ORG_DOCUMENT_CONTRACT_CREATE: 'document_contract:create',
  ORG_DOCUMENT_CONTRACT_EDIT: 'document_contract:edit', /// Check where to use
  ORG_DOCUMENT_CONTRACT_DELETE: 'document_contract:delete', /// Check where to use
  ORG_DOCUMENT_SIGN_READ: 'document_signing:read',
  ORG_DOCUMENT_SIGN: 'docs:sign',
  ORG_DOCUMENT_UPLOAD: 'docs:upload',
  ORG_DOCUMENT_EDIT: 'docs:edit',
  ORG_DOCUMENT_VIEW_ALL: 'docs:view_all',
  ORG_DOCUMENT_VIEW_RESTRICTED: 'docs:view_restricted',
  ORG_SIGNING_OWN_DOCS_MANAGE: 'signing_own_docs:manage',
  ORG_SIGNING_USERS_DOCS_MANAGE: 'signing_users_docs:manage',
  ORG_BUSINESS_PROFILE_READ: 'business_profile:read',
  ORG_BUSINESS_PROFILE_CREATE: 'business_profile:create',
  ORG_BUSINESS_PROFILE_UPDATE: 'business_profile:update',
  ORG_BUSINESS_PROFILE_CREATE_CONTACT: 'business_profile_contacts:create',
  ORG_BUSINESS_PROFILE_UPDATE_CONTACT: 'business_profile_contacts:update',
  ORG_BUSINESS_PROFILE_UPDATE_DOCUMENT: 'business_profile_documents:update',
  ORG_BUSINESS_PROFILE_CREATE_NOTE: 'business_profile_notes:create',
  ORG_BUSINESS_PROFILE_UPDATE_NOTE: 'business_profile_notes:update',
  ORG_BUSINESS_PROFILE_DELETE_CONTACT: 'business_profile_contacts:delete',
  ORG_BUSINESS_PROFILE_DELETE_DOCUMENT: 'business_profile_documents:delete',
  ORG_BUSINESS_PROFILE_DELETE_NOTE: 'business_profile_notes:delete',
  ORG_EMPLOYEE_PROFILE_READ: 'employee_profile:read',
  ORG_EDIT_EMPLOYEE: 'employee:edit',
  ORG_EMPLOYEE_PROFILE_CREATE: 'employee_profile:create',
  ORG_EMPLOYEE_PROFILE_UPDATE: 'employee_profile:update',
  ORG_EMPLOYEE_PROFILE_UPDATE_DOCUMENT: 'employee_profile_documents:update',
  ORG_EMPLOYEE_PROFILE_CREATE_NOTE: 'employee_profile_notes:create',
  ORG_EMPLOYEE_PROFILE_UPDATE_NOTE: 'employee_profile_notes:update',
  ORG_EMPLOYEE_PROFILE_DELETE_DOCUMENT: 'employee_profile_documents:delete',
  ORG_EMPLOYEE_PROFILE_DELETE_NOTE: 'employee_profile_notes:delete',
  ORG_EMPLOYEE_PROFILE_DELETE: 'employee_profile:delete',
  ORG_CUSTOMER_PROFILE_READ: 'customer_profile:read',
  ORG_CUSTOMER_PROFILE_CREATE: 'customer_profile:create',
  ORG_CUSTOMER_PROFILE_UPDATE: 'customer_profile:update',
  ORG_CUSTOMER_PROFILE_UPDATE_DOCUMENT: 'customer_profile_documents:update',
  ORG_CUSTOMER_PROFILE_DELETE: 'customer_profile:delete',
  ORG_SUPPLIER_PROFILE_READ: 'supplier_profile:read',
  ORG_SUPPLIER_PROFILE_CREATE: 'supplier_profile:create',
  ORG_SUPPLIER_PROFILE_UPDATE: 'supplier_profile:update',
  ORG_SUPPLIER_PROFILE_UPDATE_DOCUMENT: 'supplier_profile_documents:update',
  ORG_CUSTOMER_PROFILE_CREATE_NOTE: 'customer_profile_notes:create',
  ORG_CUSTOMER_PROFILE_UPDATE_NOTE: 'customer_profile_notes:update',
  ORG_CUSTOMER_PROFILE_CREATE_CONTACT: 'customer_profile_contacts:create',
  ORG_CUSTOMER_PROFILE_UPDATE_CONTACT: 'customer_profile_contacts:update',
  ORG_CUSTOMER_PROFILE_DELETE_CONTACT: 'customer_profile_contacts:delete',
  ORG_CUSTOMER_PROFILE_DELETE_DOCUMENT: 'customer_profile_documents:delete',
  ORG_CUSTOMER_PROFILE_DELETE_NOTE: 'customer_profile_notes:delete',
  ORG_SUPPLIER_PROFILE_CREATE_CONTACT: 'supplier_profile_contacts:create',
  ORG_SUPPLIER_PROFILE_UPDATE_CONTACT: 'supplier_profile_contacts:update',
  ORG_SUPPLIER_PROFILE_DELETE_CONTACT: 'supplier_profile_contacts:delete',
  ORG_SUPPLIER_PROFILE_CREATE_NOTE: 'supplier_profile_notes:create',
  ORG_SUPPLIER_PROFILE_UPDATE_NOTE: 'supplier_profile_notes:update',
  ORG_SUPPLIER_PROFILE_DELETE_NOTE: 'supplier_profile_notes:delete',
  ORG_SUPPLIER_PROFILE_DELETE: 'supplier_profile:delete',
  ORG_SUPPLIER_PROFILE_DELETE_DOCUMENT: 'supplier_profile_documents:delete',
  ORG_DOCUMENT_UPLOAD_MANAGE_BUSINESS_PROFILE: 'document_upload:manage_business_profile',
  ORG_DOCUMENT_UPLOAD_CREATE: 'document_upload:create',
  ORG_DOCUMENT_UPLOAD_ASSIGN_PROFILE: 'document_upload:assign_profile',
  ORG_DOCUMENT_UPLOAD_DELETE: 'document_upload:delete', //Add to the backend
  ORG_DOCUMENT_UPLOAD_READ: 'document_upload:read', //Add to the backend
  ORG_DOCUMENT_UPLOAD_EDIT: 'document_upload:edit', //Add to the backend
  ORG_AI_SUMMARY_CREATE: 'ai_summary:create',
  ORG_DOCUMENT_EXPORT: 'document:export',
  ORG_DOCUMENT_MANAGE: 'document:manage',
  ORG_DOCUMENT_SIGNING_CREATE: 'document_signing:create',

  //////////////////////
  ORG_DOCUMENT_UPLOAD_CUSTOMER_MANAGE: 'document_upload_customer:manage',
  ORG_DOCUMENT_UPLOAD_SUPPLIER_MANAGE: 'document_upload_supplier:manage',
  ORG_DOCUMENT_UPLOAD_EMPLOYEE_MANAGE: 'document_upload_employee:manage',
  ORG_DOCUMENT_UPLOAD_BUSINESS_MANAGE: 'document_upload_business:manage',
};
